/* ========================================================================== *\
	IMPORTS
\* ========================================================================== */

import { bind, isElement, isEmpty } from 'lodash';

import { subscribe } from '../../01-helpers/event-manager';
import { EXAM_LOADED } from '../../02-const/event-names';

/* == IMPORTS =============================================================== */



/* ========================================================================== *\
	PRIVATE VARIABLES
\* ========================================================================== */

const
    moduleName = 'exam-widget-select',
    baseCssClass = `js-${moduleName}`,

    propertyNames = {
        baseElement: Symbol('baseElement'),
        btn: Symbol('button'),
        onExamSelectedCallback: Symbol('onExamSelectedCallback'),
        dropdown: Symbol('dropdown'),
        typeId: Symbol('typeId')
    },
    selectors = {
        base: `.${baseCssClass}`,
        btn: `.${baseCssClass}-button`,
        dropdown: `.${baseCssClass}-dropdown`,
        typeId: `.${baseCssClass}-type-id`,
    }

/* == PRIVATE VARIABLES ===================================================== */



/* ========================================================================== *\
	EVENT HANDLING
\* ========================================================================== */

function bindEvents() {
    if (this.btn === null) {
        return;
    }

    this.btn.addEventListener('click', bind(onClickBtn, this));

    subscribe(EXAM_LOADED, this._setExam.bind(this));
}

function onClickBtn() {
    const
        typeId = document.querySelector(selectors.typeId),
        checkedType = typeId.querySelector('input:checked'),
        ruleId = document.querySelector(selectors.dropdown); 

    if (this.onExamSelectedCallback && checkedType !== null) {
        const
            checkedInputLabel = checkedType.nextElementSibling.innerHTML;
        let 
            selectedRuleId = '';

        if (checkedType.value == 2) {
            selectedRuleId = ruleId.options[ruleId.selectedIndex].innerHTML;
        }

        this.onExamSelectedCallback.call(this, checkedType.value, ruleId.value, checkedInputLabel, selectedRuleId);
    }
}

/* == EVENT HANDLING ======================================================== */



/* ========================================================================== *\
	PUBLIC API
\* ========================================================================== */

export class ExamSelect {

    /* ====================================================================== *\
        CONSTRUCTOR
    \* ====================================================================== */

    constructor(baseElement) {
        if (!isElement(baseElement)) {
            return false;
        }

        this.baseElement = baseElement;
        this.btn = baseElement.querySelector(selectors.btn);
        this.dropdown = baseElement.querySelector(selectors.dropdown);
        this.typeId = baseElement.querySelector(selectors.typeId);
        this.hashUrl = window.location.hash;

        bindEvents.call(this);
    }

    /* == CONSTRUCTOR ======================================================= */

    _setExam() {
        if (isEmpty(this.hashUrl)) {
            return false;
        }

        this.exam = this.baseElement.querySelector(`input[data-name="${this.hashUrl}"]`);
        if (isElement(this.exam)) {
            this.exam.checked = true;
        }

        this.btn.click();
    }

    onExamSelected(callback) {
        this.onExamSelectedCallback = callback;
    }
}

/* == PUBLIC API ============================================================ */



/* ========================================================================== *\
	EXPORTS
\* ========================================================================== */

export default ExamSelect;

/* == EXPORTS =============================================================== */